import { ArrowDownCircle, ArrowUpCircle, Clock, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Mask } from "@/utils/mask";
import { cn } from "@/lib/utils";
import { CashFlowTotals } from "@/types/cashFlow";

type SummaryCardsProps = {
  totals: CashFlowTotals;
  pendingTotals: CashFlowTotals;
};

const CardsRow = ({
  cards,
}: {
  cards: {
    title: string;
    value: number;
    icon: typeof Scale;
    color: string;
    muted?: boolean;
    reconciled?: boolean;
  }[];
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
    {cards.map(({ title, value, icon: Icon, color, muted, reconciled }) => (
      <Card key={title} className={cn(
          muted && "border-dashed bg-gray-50",
          reconciled && "border-green-200 bg-green-50",
        )}>
        <CardContent className="p-6 flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">
              {title}
            </p>
            <p className={cn("text-2xl font-bold", color)}>
              {Mask.formatCurrency(value)}
            </p>
          </div>
          <Icon className={cn("h-8 w-8", color)} />
        </CardContent>
      </Card>
    ))}
  </div>
);

export const SummaryCards = ({ totals, pendingTotals }: SummaryCardsProps) => {
  const projected = totals.balance + pendingTotals.balance;

  return (
    <div className="mb-2">
      <CardsRow
        cards={[
          {
            title: "Entradas Conciliadas",
            value: totals.inflow,
            icon: ArrowDownCircle,
            color: "text-green-600",
            reconciled: true,
          },
          {
            title: "Saídas Conciliadas",
            value: totals.outflow,
            icon: ArrowUpCircle,
            color: "text-red-600",
            reconciled: true,
          },
          {
            title: "Fluxo de Caixa Conciliado",
            value: totals.balance,
            icon: Scale,
            color: totals.balance < 0 ? "text-red-600" : "text-blue-600",
            reconciled: true,
          },
        ]}
      />
      <CardsRow
        cards={[
          {
            title: "A conciliar - Entradas",
            value: pendingTotals.inflow,
            icon: Clock,
            color: "text-amber-600",
            muted: true,
          },
          {
            title: "A conciliar - Saídas",
            value: pendingTotals.outflow,
            icon: Clock,
            color: "text-amber-600",
            muted: true,
          },
          {
            title: "Saldo previsto",
            value: projected,
            icon: Scale,
            color: "text-amber-600",
            muted: true,
          },
        ]}
      />
    </div>
  );
};
